import moment from "moment";
import path from "path";
export const getLayoutDataByID = (contentJson, layoutID) => {
  for (var i = 0; i < contentJson.layouts.length; i++) {
    if (contentJson.layouts[i].layout_id === layoutID) {
      return contentJson.layouts[i];
    }
  }

  return null;
};

export const getPlaylistDataByID = (contentJson, playlistID) => {
  for (var i = 0; i < contentJson.playlists.length; i++) {
    if (`${contentJson.playlists[i].playlist_id}` === `${playlistID}`) {
      return contentJson.playlists[i];
    }
  }

  return null;
};

export const getPlaylistIDBySlot = (timelinedata, slotID) => {
  // console.log("slot_id " + JSON.stringify(timelinedata.slots))
  const slotsJSON = timelinedata.slots//JSON.parse(timelinedata.slots);
  // console.log("slot_id " + slotsJSON.length)
  if (slotID in slotsJSON) {
    return slotsJSON[slotID];
  }

  return null;
};

export const getTimelineElementPlaytimeOffset = (timelineElement) => {
  if ("startplaytime" in timelineElement) {
    // console.log("has start end time");
    var d = new Date();
    var startTimeArr = timelineElement.startplaytime.split(":");

    var startTimeD = new Date();
    startTimeD.setHours(startTimeArr[0], startTimeArr[1], 0, 0);

    // var endTimeD = new Date(startTimeD.getTime());
    // endTimeD.setSeconds(endTimeD.getSeconds() + timelineElement.duration);

    // console.log("h " + startTimeArr[0])
    // console.log("m " + startTimeArr[1])

    // console.log("d diff " + d.getTime())
    // console.log("start diff " + startTimeD.getTime())
    const timeDiff = (d.getTime() - startTimeD.getTime()) / 1000;

    // console.log("time diff " + timeDiff)
    return Math.round(timeDiff);
  }

  return 0;
};

export const prepareTimelines = (timelines) => {

  // var totalDuration = 0;

  for (var j = 0; j < timelines.length; j++) {
    var timeline = timelines[j];
    var totalElementDuration = 0;
    for (var i = 0; i < timeline.timeline_element.length; i++) {

      if ("duration" in timeline.timeline_element[i]) {
        timeline.timeline_element[i].stackedDuration = totalElementDuration;
        totalElementDuration = totalElementDuration + timeline.timeline_element[i].duration;
      }
    }

    // if (timeline.timeline_element.length) {

    //   if ("duration" in timeline.timeline_element[0]) {
    //     timeline.stackedDuration = totalDuration;
    //     timeline.duration = timeline.timeline_element[0].duration;
    //     totalDuration = totalDuration + timeline.timeline_element[0].duration;
    //   }
    //   else {
    //     timeline.duration = 0;
    //   }
    // }

  }
};

export const prepareTimelineElements = (elements) => {
  for (var j = 0; j < elements.length; j++) {
    var timeline = elements[j];
    var totalDuration = 0;
    for (var i = 0; i < timeline.timeline_element.length; i++) {

      // if ("layout" in timeline.timeline_element[i]) {
      //   timeline.timeline_element[i].layout = JSON.parse(timeline.timeline_element[i].layout);
      // }
      // if ("slots" in timeline.timeline_element[i]) {
      //   timeline.timeline_element[i].slots = JSON.parse(timeline.timeline_element[i].slots);
      // }
      if ("duration" in timeline.timeline_element[i]) {
        // console.log(totalDuration);
        timeline.timeline_element[i].stackedDuration = totalDuration;
        totalDuration = totalDuration + timeline.timeline_element[i].duration;
      }
    }
  }
};

export const preparePlaylists = (playlists, forPreview = false) => {
  for (var i = 0; i < playlists.length; i++) {
    preparePlaylistData(playlists[i], forPreview);
  }
};


export const preparePlaylistData = (playlistData, forPreview = false) => {
  var d = new moment();
  var totalTime = 0;
  // console.log("---------preparePlaylistData---------")
  for (var i = 0; i < playlistData.contents.length; i++) {
    var isFileAndMediaActive = true;

    var mediaData = playlistData.contents[i];

    const checkIsVideo = (fileName) => {
      const videoExtensions = ["mp4", "avi", "mov"];
      const ext = path.extname(fileName).toLocaleLowerCase().replace(".", "")

      return videoExtensions.some((extName) => {
        // console.log("asdasdasda")
        // console.log(extName)
        // console.log(ext)
        // console.log(ext === extName.toLocaleLowerCase())

        return ext === extName.toLocaleLowerCase()
      });
    }

    // mediaData.type = checkIsVideo(path.basename(mediaData.path)) ? "video" : "image"

    if (!forPreview) {
      if (mediaData.type !== "web" && mediaData.type !== "widget")
        mediaData.path = "http://localhost:9990/assets/" + path.basename(mediaData.path)
    }
    // console.log("preparePlaylistData")

    mediaData.duration = Math.floor(mediaData.duration);
    //check if file active
    if ("filestartdate" in mediaData && "fileenddate" in mediaData) {
      if (mediaData.filestartdate !== "" && mediaData.fileenddate !== "") {
        var filestartDate = moment(
          mediaData.filestartdate + "T00:00",
          "YYYY-MM-DDTHH:mm"
        );
        var fileendDate = moment(
          mediaData.fileenddate + "T23:59",
          "YYYY-MM-DDTHH:mm"
        );

        if (!d.isBetween(filestartDate, fileendDate)) {
          isFileAndMediaActive = false;
        }
      }
    }

    //check if media active
    if ("startdate" in mediaData && "enddate" in mediaData) {
      if (mediaData.startdate !== "" && mediaData.enddate !== "") {
        var startDate = moment(
          mediaData.startdate + "T00:00",
          "YYYY-MM-DDTHH:mm"
        );
        var endDate = moment(mediaData.enddate + "T23:59", "YYYY-MM-DDTHH:mm");

        if (!d.isBetween(startDate, endDate)) {
          isFileAndMediaActive = false;
        }
      }
    }
    // console.log(mediaData.media_id + " " +  isFileAndMediaActive);

    //if not active set duration to 0 so it won't be played
    if (!isFileAndMediaActive) {
      playlistData.contents[i].duration = 0;
    }


    playlistData.contents[i].playlist_start_time = totalTime;
    totalTime = totalTime + playlistData.contents[i].duration;
  }

  playlistData.total_time = totalTime;
};
